<template>
  <div class="site-inspection-dialog">
    <v-dialog v-model="dialog.inspectionDialog" scrollable>
      <v-card>
        <v-card-title>{{ item.name }} 점검기록</v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="end">

              <v-btn large color="black" class="ma-2" text @click="openDialog(item, 'addInspectionDialog')">
                <v-icon large>add</v-icon>
                점검기록 추가
              </v-btn>

              <v-dialog v-model="dateRangeDialog" width="800">
                <v-card>
                  <v-card-title>
                    범위 선택
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <v-menu transition="scale-transition" max-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="dateRange.startDate"
                                :rules="notEmptyValidation"
                                label="시작일자"
                                readonly
                                v-on="on"
                                required/>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title scrollable :show-current="false"/>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-menu transition="scale-transition" max-width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="dateRange.endDate"
                                :rules="notEmptyValidation"
                                label="종료일자"
                                readonly
                                v-on="on"
                                required/>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title scrollable :show-current="false"/>
                          </v-menu>
                        </v-col>
                      </v-row>

                      <v-row justify="center">
                        <v-btn text @click="subtractFromNow(7, 'days', '최근 7일', true)">최근 7일</v-btn>
                        <v-btn text @click="subtractFromNow(1, 'months', '최근 1개월', true)">최근 1개월</v-btn>
                        <v-btn text @click="subtractFromNow(6, 'months', '최근 6개월', true)">최근 6개월</v-btn>
                        <v-btn text @click="subtractFromNow(1, 'years', '최근 1년', true)">최근 1년</v-btn>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-container>
                      <v-row justify="end">
                        <v-btn text color="error" @click="setRangeAndSearch">검색</v-btn>
                        <v-btn text @click="dateRangeDialog = false">취소</v-btn>
                      </v-row>
                    </v-container>
                  </v-card-actions>
                </v-card>
                <template v-slot:activator="{ on }">
                  <v-btn large color="black" class="ma-2" text v-on="on">
                    <v-icon large>date_range</v-icon>
                    {{ dateRange.rangeText }}
                  </v-btn>
                </template>
              </v-dialog>
            </v-row>

            <v-row>
              <v-col>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left" width="200px">기록일</th>
                      <th class="text-left">제목</th>
                      <th class="text-left">내용</th>
                      <th width="100px">&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="inspection in siteInspections" :key="inspection.id"
                        @click="openDialog(inspection, 'viewInspectionDialog')">
                      <td>{{ getTimestampString(inspection.createdTimestamp) }}</td>
                      <td>{{ cutLongContents(inspection.title, 30) }}</td>
                      <td>{{ cutLongContents(inspection.contents, 20) }}</td>
                      <td>
                        <v-icon small class="mr-2" @click.stop="openDialog(inspection, 'updateInspectionDialog')">edit</v-icon>
                        <v-icon small class="mr-2" @click.stop="openDialog(inspection, 'deleteInspectionDialog')">delete</v-icon>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-dialog v-model="dialog.addInspectionDialog" max-width="800">
          <AddSiteInspectionDialog :dialog="dialog" :item="dialogData"/>
        </v-dialog>
        <v-dialog v-model="dialog.viewInspectionDialog" max-width="800">
          <ViewInspectionDialog :dialog="dialog" :item="dialogData"/>
        </v-dialog>
        <v-dialog v-model="dialog.deleteInspectionDialog" max-width="400">
          <DeleteInspectionDialog :dialog="dialog" :item="dialogData"/>
        </v-dialog>
        <v-dialog v-model="dialog.updateInspectionDialog" max-width="800">
          <UpdateSiteInspectionDialog :dialog="dialog" :item="dialogData"/>
        </v-dialog>

        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="dialog.inspectionDialog = false">확인</v-btn>
          <v-btn text @click="downloadExcel(0, 100)"><v-icon>fa-file-download</v-icon>&nbsp;엑셀 다운로드</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'

  import AddSiteInspectionDialog from './AddSiteInspectionDialog'
  import ViewInspectionDialog from "./ViewSiteInspectionDialog";
  import DeleteInspectionDialog from "./DeleteSiteInspectionDialog";
  import UpdateSiteInspectionDialog from "./UpdateSiteInspectionDialog";

  export default {
    name: 'siteInspectionDialog',
    components: {
      UpdateSiteInspectionDialog,
      AddSiteInspectionDialog,
      ViewInspectionDialog,
      DeleteInspectionDialog
    },
    props: {
      dialog: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        siteInspections: [
        ],
        dateRangeDialog: false,
        dateRange: {
          rangeText: '최근 6개월',
          startDate: '1989-03-09',
          endDate: '2099-12-31'
        },
        notEmptyValidation: [
          value => !!value || '필수 값입니다'
        ],
        dialogData: {
        }
      }
    },
    methods: {
      searchSiteInspection(page = 0, size = 100) {
        const retryFuncBackup = this.searchSiteInspection.bind(this);
        // TODO : 여기 pagination 작업해야 함!!!!!

        const siteId = this.item.siteId;
        const endTimestamp = moment(`${this.dateRange.endDate}T23:59:59.999+09:00`).valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T00:00:00.000+09:00`).valueOf();

        console.log(`search inspection : ${siteId}, ${startTimestamp} ~ ${endTimestamp}`);

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteInspections?siteId=${siteId}&page=${page}&size=${size}&startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        axios.get(targetUri, config)
          .then(result => {
            this.siteInspections = result.data;

            console.log('siteInspections data loaded')
            console.dir(this.siteInspections);
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      setRangeAndSearch() {
        this.dateRange.rangeText = `${this.dateRange.startDate} ~ ${this.dateRange.endDate}`;
        this.dateRangeDialog = false;
        this.searchSiteInspection();
      },
      downloadExcel(page = 0, size = 100) {
        const retryFuncBackup = this.downloadExcel.bind(this);

        const siteId = this.item.siteId;
        const endTimestamp = moment(`${this.dateRange.endDate}T23:59:59.999+09:00`).valueOf();
        const startTimestamp = moment(`${this.dateRange.startDate}T00:00:00.000+09:00`).valueOf();

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteInspections/_excel?siteId=${siteId}&page=${page}&size=${size}&startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          },
          responseType: 'blob'
        };

        axios.get(targetUri, config)
          .then(result => {
            console.log('excel download');
            console.dir(result);
            let fileName = result.headers["content-disposition"].split("filename=")[1];
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE인 경우에
              window.navigator.msSaveOrOpenBlob(new Blob([result.data],
                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                fileName);
            } else {
              const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', result.headers["content-disposition"].split("filename=")[1]);
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      subtractFromNow(amount, unit, rangeText, searchNow) {
        const now = moment();
        this.dateRange.endDate = now.format('YYYY-MM-DD');

        // 이 때 now값 자체도 변해버리는듯하니 주의(그러니까 사실은 startMoment로 받지 않아도 된다)
        const startMoment = now.subtract(amount, unit);
        this.dateRange.startDate = startMoment.format('YYYY-MM-DD');

        if (rangeText) {
          this.dateRange.rangeText = rangeText;
        }

        this.dateRangeDialog = false;

        if (searchNow) {
          this.searchSiteInspection();
        }
      },
      getTimestampString(timestamp) {
        return moment(timestamp).format('YYYY-MM-DD');
      },
      cutLongContents(contents, maxSize) {
        if (contents.length > maxSize) {
          return contents.substring(0, maxSize - 3) + '...';
        }

        return contents;
      },
      openDialog(item, dialogName) {
        if (!dialogName) {
          this.popupAlert('under construction', 'info');
          return;
        }

        this.dialogData = Object.assign({}, item);
        this.dialog[dialogName] = true;
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    },
    mounted() {
      this.subtractFromNow(6, 'months', '최근 6개월', false);
      this.$bus.$on('refreshSiteInspections', this.searchSiteInspection);
      this.searchSiteInspection();
    }
  }
</script>